export default function isInZone(changingPos: number, staticPos: number): { inZone: boolean; diff: number } {
  const presision = 5;
  const diff = changingPos - staticPos;
  return { inZone: Math.abs(diff) <= presision, diff };
}
